export function formatDate(dateToFormat: string) {
    return new Date(dateToFormat).toLocaleString('ru', {weekday: "short", day: "numeric", month: "numeric", year: "numeric"})
}